import React from 'react';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import './LineItemCustomization.scss';

type Props = {
  item: LineItem;
};

export const LineItemCustomization: React.FC<Props> = ({
  item: {
    attributes: { customization }
  }
}) => {
  if (!customization) return null;

  return (
    <div>
      <div className="LineItemCustomization__label">Personalization</div>
      <div data-test-id="line-item-customization-text">{customization}</div>
    </div>
  );
};
